import React, { Component } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import { ToastContainer, toast } from 'react-toastify';
import { apiClient,apiBaseUrl } from "../helpers/common";
import $ from 'jquery'
import axios from "axios";

class AddProduct extends Component {

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();

        this.state = {
            name: '',
            image: '',
            weight: '',
            weight_type:'kg',
            size: '',
            description: '',
            seller: '',
            store:'',
            category: '',
            loading: false,
            file:'',
            categoryList:[],
            sellerList:[],
            storesList: [],
            product_id:'',
            price:0,
            rating:'1',
            IsEdit:false
        }
    }

    componentDidMount() {
       this.getCategoryList();
       this.getSellerList();
       this.getStoresList();
       console.log("id",this.props.product_id)
       if(this.props.product_id !== ''){
          this.setState({
            product_id:this.props.product_id,
            IsEdit:true
          },()=>{
            this.getProductDetail(this.state.product_id); 
            this.props.handleEditRequest('')
          })
       }
    }
    componentDidUpdate() {

    }

    handleInputValue = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    submitForm = async (e) => {
        e.preventDefault();
       
        const { IsEdit,name,weight_type, description,image,weight,size,store,category,product_id,rating,price} = this.state

        let img = ''
        if(image !== ''){
           let imgdata = image.split("/")
            img = imgdata[imgdata.length -1]
        }
        if(IsEdit){
            if (this.validator.allValid()) {
                let postData = {
                    token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
                    name,
                    image:img,
                    description,
                    weight,
                    size,
                    store,
                    category,
                    rating,
                    price,
                    weight_type,
                    uuid:product_id
                }
    
                const result = await apiClient('update-product', {
                    method: 'POST',
                    body: postData
                });
        
                if (result.status === 200) {
                    this.props.handlePages('products')
                }
            } else {
                this.validator.showMessages();
                this.forceUpdate();
            }
        }else{
            if (this.validator.allValid()) {
                let postData = {
                    token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
                    name,
                    image:img,
                    description,
                    weight,
                    size,
                    store,
                    category,
                    rating,
                    price,
                    weight_type,
                }
    
                const result = await apiClient('add-product', {
                    method: 'POST',
                    body: postData
                });
        
                if (result.status === 200) {
                    this.props.handlePages('products')
                }
            } else {
                this.validator.showMessages();
                this.forceUpdate();
            }
        }
      
    }

    onSelectFile = e => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener('load', () =>
                this.setState({ file: reader.result })
            );
            reader.readAsDataURL(e.target.files[0]);
        }
        e.preventDefault();
    }

    handleChangeFile=(event)=>{
        const file = event.target.files[0];
        console.log("file",file)
        const formData = new FormData();
        formData.append('file', file);
     

        axios.post(`${apiBaseUrl}/upload-image`,formData).then(res => {
            if(res.status === 200){
               let img = res.data.data.ImagePath
               this.setState({image:img})
            }
          
        })
    }

    getCategoryList = async () => {
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
        }

        const result = await apiClient('categories-listing', {
            method: 'POST',
            body: postData
        });

        if (result.status === 200) {
          this.setState({categoryList:result.data})
        }
    }

    getSellerList = async () => {
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
        }

        const result = await apiClient('sellers-listing', {
            method: 'POST',
            body: postData
        });

        if (result.status === 200) {
          this.setState({sellerList:result.data})
        }
    }

    getStoresList = async () => {
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
        }

        const result = await apiClient('stores-listing', {
            method: 'POST',
            body: postData
        });

        if (result.status === 200) {
            this.setState({storesList:result.data})
          
        } 
    }

    getProductDetail = async (id) => {
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
            uuid:id
        }

        const result = await apiClient('product-detail', {
            method: 'POST',
            body: postData
        });

        if (result.status === 200) {
            let data = result.data[0]
           
            this.setState({
                name: data.name,
                image: data.image,
                weight: data.weight,
                price:data.price,
                rating:data.rating,
                store: data.store,
                size: data.size,
                description: data.description,
                seller: data.seller,
                category: data.category,
                weight_type: data.weight_type
            })
   
        }
    }
    render() {
        const {IsEdit} = this.state
   
        return (<>
            <div className="page_content">
                <section className="upper_section">
                    <div className="page_heading row">
                <h3><span className="title">{IsEdit? 'Edit' : 'Add'} Product</span></h3>
                        <div className="page_actions">
                           
                        </div>
                    </div>
                </section>
                <section className="lower_section">
                    <div className="row">
                        <div class="col-md-12">
                            <div class="c-pannel">

                                <div className="row">
                                    <div className="col-md-12">
                                        <form onSubmit={(e) => this.submitForm(e)}>
                                            <div className="form-group">
                                                <label className="">Name</label>
                                                <input type="text" name="name" value={this.state.name} onChange={(e) => this.handleInputValue(e)} className="form-control" />
                                                {this.validator.message('name', this.state.name, 'required', { messages: { default: 'Name field is required.'} })}

                                            </div>
                                            <div className="form-group">
                                                <label className="">Category</label>
                                            
                                               <select className ="form-control"
                                                  name ="category"
                                                  value={this.state.category}
                                                  onChange={(e) => this.handleInputValue(e)} 
                                               >
                                                   <option value=''>Select Category</option>
                                                   {
                                                      this.state.categoryList.map((val)=>{
                                                           return(
                                                                <option value={val.uuid}>{val.category}</option>
                                                           )
                                                          
                                                       })
                                                   }
                                                
                                               </select>
                                                {this.validator.message('category', this.state.category, 'required', { messages: { default: 'Category field is required.' } })}
                                            </div>
                                            {/* <div className="form-group">
                                                <label className="">Seller</label>
                                                <select className ="form-control"
                                                  name ="seller"
                                                  value={this.state.seller}
                                                  onChange={(e) => this.handleInputValue(e)} 
                                               >
                                                <option value=''>Select Seller</option>
                                                   {
                                                      this.state.sellerList.map((val)=>{
                                                           return(
                                                                <option value={val.uuid}>{val.name}</option>
                                                           )
                                                          
                                                       })
                                                   }
                                                
                                               </select>
                                              
                                                {this.validator.message('seller', this.state.seller, 'required', { messages: { default: 'Seller field is required.' } })}
                                            </div> */}
                                              <div className="form-group">
                                                <label className="">Store</label>
                                                <select className ="form-control"
                                                  name ="store"
                                                  value={this.state.store}
                                                  onChange={(e) => this.handleInputValue(e)} 
                                               >
                                                <option value=''>Select Store</option>
                                                   {
                                                      this.state.storesList.map((val)=>{
                                                           return(
                                                                <option value={val.uuid}>{val.name}</option>
                                                           )
                                                          
                                                       })
                                                   }
                                                
                                               </select>
                                              
                                                {this.validator.message('store', this.state.store, 'required', { messages: { default: 'Store field is required.' } })}
                                            </div>
                                            <div className="form-group">
                                                <label className="">Image</label>
                                                <input type="file" name="file" accept="image/*"  onChange={(e) => this.handleChangeFile(e)} className="form-control" />
                                                {
                                                    this.state.image !== '' ? <>
                                                    <img height="50" width="50" src={this.state.image}/>
                                                     </> :''
                                                }
                                                {this.validator.message('image', this.state.image, 'required', { messages: { default: 'Image is required.' } })}
                                            </div>
                                            <div className="form-group">
                                                <label className="">Size</label>
                                                <input type="text" name="size" value={this.state.size} onChange={(e) => this.handleInputValue(e)} className="form-control" />
                                                {this.validator.message('size', this.state.size, 'required', { messages: { default: 'Size field is required.' } })}
                                            </div>
                                            <div className="form-group">
                                                <label className="">Weight</label>
                                                <div className="row">
                                                    <div className="col-md-8">
                                                    <input type="number" min="0" step="0.01"  name="weight" value={this.state.weight} onChange={(e) => this.handleInputValue(e)} className="form-control" />
                                                    </div>
                                                    <div className="col-md-4">
                                                    <select className ="form-control"
                                                        name ="weight_type"
                                                        value={this.state.weight_type}
                                                        onChange={(e) => this.handleInputValue(e)} 
                                                    >
                                                            <option>kg</option>
                                                            <option >ltr</option>
                                                        
                                                    </select>
                                                      </div>
                                                </div>
                                               
                                                
                                                {this.validator.message('weight', this.state.weight, 'required', { messages: { default: 'Weight field is required.' } })}
                                            </div>
                                            <div className="form-group">
                                                <label className="">Price</label>
                                                <input type="number" step="0.01" min="0" name="price" value={this.state.price} onChange={(e) => this.handleInputValue(e)} className="form-control" />
                                                {this.validator.message('weight', this.state.price, 'required', { messages: { default: 'Price field is required.' } })}
                                            </div>
                                            <div className="form-group">
                                            <label className="">Rating</label>
                                            <select className ="form-control"
                                                  name ="rating"
                                                  value={this.state.rating}
                                                  onChange={(e) => this.handleInputValue(e)} 
                                               >
                                               
                                                    {
                                                        Array.from(Array(5), (_, i) => i + 1).map((val) => {

                                                            return (<>
                                                                <option value={val}>{val}</option>
                                                            </>)
                                                        })
                                                    }
                                                
                                               </select>
                                               {this.validator.message('rating', this.state.rating, 'required', { messages: { default: 'Rating field is required.' } })}
                                            </div>
                                            <div className="form-group">
                                                <label className="">Description</label>
                                                <textarea name="description" rows={3} maxLength={500} value={this.state.description} onChange={(e) => this.handleInputValue(e)} className="form-control">

                                                </textarea>

                                                {this.validator.message('description', this.state.description, 'required', { messages: { default: 'Description field is required.' } })}
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-12 text-right">
                                                    
                                                    <button type="submit" className="btn btn-green btn-mini float-right">{IsEdit? 'Update' : 'Save'}</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>


        </>)
    }
}
export default AddProduct